export const cmvrCenterEditComponent = {
  template: `<cmvr-center-main details="$ctrl.details" />`,
  bindings: {
    details: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/components/cmvr-center/cmvr-center-edit/cmvr-center-edit.component.js